import { SET_SELECTED, TOGGLE_FETCH_MEDICAL_STATUS } from "./actions";

export const initialState = {
  getMedicalStatus: true,
  filters: {
    overall_status: [],
    status: [],
  },
};

export function dashboardReducer(state, action) {
  switch (action.type) {
    case SET_SELECTED: {

      return {
        ...state,
        getMedicalStatus:true,
        filters: {
          ...state.filters,
          [action.payload.filterName]: action.payload.filterValue,
        },
      };
    }

    case TOGGLE_FETCH_MEDICAL_STATUS: {
      return { ...state, getMedicalStatus: action.payload }
    }
    default:
      return state;
  }
}
